import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import cx from 'classnames'
import useMedia from 'use-media'

import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	const isTablet = useMedia({ minWidth: '768px' })

	return (
		<Section className={styles.directions} fullWidth>
			<h2 className={styles.heading}>{data.heading}</h2>
			<div className={styles.wrapper}>
				{data.directions.map((el, i) => {
					return (
						<div className={styles.direction} key={i}>
							<div className={styles.directionWrapper}>
								<p className={styles.companyName}>{el.company}</p>
								<p
									className={cx(styles.directionName, {
										[styles[`${el.color}Color`]]: true,
									})}
								>
									{el.name}
								</p>
							</div>

							<div className={styles.contentWrapper}>
								{el.content.map((content) => (
									<div key={content} className={styles.content}>
										{content}
									</div>
								))}
							</div>

							<a
								href={data.advantages[i].href}
								className={cx(styles.advantage, {
									[styles.long]: isTablet && el.color !== 'blue',
								})}
							>
								<div className={styles.wrapperText}>{data.advantages[i].text}</div>
								<div
									className={cx(
										styles.imageContainer,
										styles[`${data.advantages[i].color}Background`]
									)}
								>
									<Image name={data.advantages[i].img} />
								</div>
							</a>
						</div>
					)
				})}
			</div>
		</Section>
	)
}
